import spinnerStyle from './spinnerStyle';
import { jsx as ___EmotionJSX } from "@emotion/react";

var Spinner = function Spinner(_ref) {
  var className = _ref.className,
      color = _ref.color;
  return ___EmotionJSX("svg", {
    className: className,
    height: "16",
    viewBox: "0 0 54 54",
    width: "16",
    xmlns: "http://www.w3.org/2000/svg"
  }, ___EmotionJSX("title", null, "Spinner"), ___EmotionJSX("g", {
    css: spinnerStyle,
    fill: color,
    fillRule: "nonzero"
  }, ___EmotionJSX("g", {
    transform: "translate(24)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(30 15 71.785)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(60 15 47.785)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(90 15 39)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(120 15 33.928)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(150 15 30.215)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(180 15 27)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(-150 15 23.785)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(-120 15 20.072)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(-90 15 15)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(-60 15 6.215)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  })), ___EmotionJSX("g", {
    transform: "rotate(-30 15 -17.785)"
  }, ___EmotionJSX("rect", {
    height: "12",
    rx: "3",
    width: "6"
  }))));
};

export default Spinner;